import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/login',
        name: 'Login',
        component: () =>
            import ('../components/Login.vue')
    },
    {
        path: '/home',
        name: 'Home',
        redirect: '/welcome',
        component: () =>
            import ('../views/Home'),
        children: [{
                path: '/welcome',
                component: () =>
                    import ('../components/Welcome')
            },
            {
                path: '/users',
                component: () =>
                    import ('../components/users/Users')
            },
            {
                path: '/publishlist',
                component: () =>
                    import ('../components/publishTask/PublishList.vue')
            },
            {
                path: '/box',
                component: () =>
                    import ('../components/publishTask/Box.vue')
            },
            {
                path: '/todolist',
                component: () =>
                    import ('../components/processTask/TodoList.vue')
            },
            {
                path: '/mytodolist',
                component: () =>
                    import ('../components/processTask/MyTodoList.vue')
            },
            {
                path: '/datalist',
                component: () =>
                    import ('../components/dataManage/DataManage.vue')
            }
        ],
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ('../views/About.vue')
    }
]

const router = new VueRouter({
    routes
})


//路由导航守卫
router.beforeEach((to, from, next) => {
    if (to.path === '/login') return next()
    const tokenStr = window.sessionStorage.getItem('token')
    if (!tokenStr) return next('/login')
    next()
})
export default router